import type { ClientResponse, ExecutorResponse } from '@/core/generated/api';
import type { ChatDialogSearchFilter } from '@/entities/ChatDialog/model/types';
import type { ChatInboxFilterValues } from './model/types';

/** Подготавливает пустые условия поиска */
export const createChatInboxFilterValues = (): ChatInboxFilterValues => ({
    companionRole: null,
    clients: [],
    executors: [],
    channels: [],
    companionName: '',
    petName: '',
});

/** Подготавливает клиента для поиска переписки */
export const clientToChatFilterPerson = (
    client: ClientResponse
): ChatInboxFilterValues['clients'][number] | null => (
    client.id && client.appUserId
        ? {
            id: client.id,
            appUserId: client.appUserId,
            name: [client.firstName, client.phone].filter(Boolean).join(' · ')
        }
        : null
);

/** Подготавливает исполнителя для поиска переписки */
export const executorToChatFilterPerson = (
    executor: ExecutorResponse
): ChatInboxFilterValues['executors'][number] | null => (
    executor.id && executor.appUserId
        ? {
            id: executor.id,
            appUserId: executor.appUserId,
            name: [executor.name, executor.lastName, executor.phone].filter(Boolean).join(' · ')
        }
        : null
);

/** Подготавливает условия поиска на сервере */
export const chatInboxFilterToSearch = (values: ChatInboxFilterValues): ChatDialogSearchFilter => ({
    appUserIds: [...new Set([...values.clients, ...values.executors].map((person) => person.appUserId))],
    filterPeople: values.clients.length + values.executors.length > 0,
    companionName: values.companionName,
    petName: values.petName,
    channels: values.channels,
    companionRole: values.companionRole ?? undefined,
});
